import * as React from "react";
import { useEffect } from "react";
import { Route, Routes, useNavigate } from "react-router-dom";
import { isNil } from "ramda";

import { Card } from "affinityUI/elements/card";
import { LayoutWrapper } from "affinityUI/structures/layout";
import { LandingPage } from "components/pages/landing";
import { PatientsIndex } from "components/pages/patients";
import { SettingsIndex } from "components/pages/settings";
import { SupportIndex } from "components/pages/support";
import { UsersIndex } from "components/pages/users";
import { useAuth } from "lib/auth";
import { pageNotFound } from "lib/errorHandler";
import { ErrorNoHospital } from "lib/errorHandler/components/errorNoHospital";
import { Page } from "lib/page";

import { AppNavigation } from "./components/appNavigation";
const App: React.FC = () => {
  const navigate = useNavigate();
  const [, { currentUser, loading }] = useAuth();

  const { DD_RUM } = window as unknown as {
    DD_RUM?: {
      onReady: (callback: () => void) => void;
      setGlobalContextProperty: (key: string, value: unknown) => void;
    };
  };

  // Redirect to login if user is not authenticated and auth has finished loading
  useEffect(() => {
    if (!loading && isNil(currentUser)) {
      navigate("/login");
    }
  }, [currentUser, loading, navigate]);

  useEffect(() => {
    if (!isNil(currentUser) && !isNil(DD_RUM)) {
      DD_RUM.onReady(function () {
        DD_RUM.setGlobalContextProperty("hospital", {
          id: currentUser.hospital?.id,
          name: currentUser.hospital?.name,
        });
        DD_RUM.setGlobalContextProperty("usr.role", {
          id: currentUser.role?.id,
          name: currentUser.role?.name,
          permissions: currentUser.role?.permissions,
        });
        DD_RUM.setGlobalContextProperty("usr.id", currentUser.id);
      });
    }
  }, [currentUser, DD_RUM]);

  // Don't render anything while loading or while redirecting unauthenticated users
  if (loading || isNil(currentUser)) {
    return null;
  }

  if (isNil(currentUser.role) || isNil(currentUser.hospital)) {
    return (
      <LayoutWrapper>
        <Card>
          <ErrorNoHospital />
        </Card>
      </LayoutWrapper>
    );
  }
  return (
    <>
      <AppNavigation />
      <Routes>
        {pageNotFound}
        <Route path="/" element={<LandingPage />} />
        <Route path="support/*" element={<Page element={<SupportIndex />} />} />
        <Route path="patients/*" element={<Page element={<PatientsIndex />} />} />
        <Route path="users/*" element={<Page element={<UsersIndex />} />} />
        <Route path="settings/*" element={<Page element={<SettingsIndex />} />} />
      </Routes>
    </>
  );
};

export default App;
